// @flow

import React from 'react';
import { Grid, Row, Col, Button } from 'react-bootstrap/lib';
import { observer } from 'mobx-react';
import styler from 'react-styling';

import 'react-select/dist/react-select.css';

import Spinner from '../Spinner';
import ResourcesEditList from '../ResourcesEditList';

const style = styler `
  Admin
    background-color: #EAEFFA
    border-left: 1px solid #ECECEC
`;

type Props = {
  resourcesEditList: Object,
  loading: boolean,
  showContactInfoMobile: boolean,
  toggleContactInfoMobile: Function,
  emails: string[],
  clearList: Function,
  languagedata: Object,
};

const ProtectedContacts = (props: Props) => (
  <Grid fluid>
    <Row>
      <Col md={8} style={style.Admin} className={`user-info ${(props.showContactInfoMobile ? ' show-user-info' : '')}`}>
        <Button
          onClick={() => props.toggleContactInfoMobile(false)}
          bsSize="small"
          className="hide-user-info hidden-md hidden-lg"
        >
          <i className="fa fa-close text-muted" />
        </Button>
        {props.loading === true ?
          <Spinner /> :
            <div>
              <ResourcesEditList
                resourcesEditList={props.resourcesEditList}
                emails={props.emails}
                clearList={props.clearList}
                languagedata={props.languagedata}
              />
            </div>
        }
      </Col>
    </Row>
  </Grid>
);

export default observer(ProtectedContacts);



// WEBPACK FOOTER //
// ./src/js/Components/Protected/ProtectedContacts.js